import { UserCoordinates } from '../../../state/user.repository';

// TODO: refactor or remove after testing
export function calcSpatialVolume(
  maxDistance: number,
  listener: UserCoordinates,
  sender: UserCoordinates,
  senderVolume: number
): [number, number] {
  // 1) compute relative vector
  const dx = sender.x - listener.x;
  const dy = sender.y - listener.y; // forward component
  const dz = sender.z - listener.z; // vertical

  // 2) distance attenuation
  const dist = Math.hypot(dx, dy, dz);
  if (dist >= maxDistance) return [0, 0];
  const distanceFactor = 1 - dist / maxDistance;

  // 3) pan angle: -1 = full left, +1 = full right
  const panAngle = Math.atan2(dx, dy);
  const pan = Math.sin(panAngle);

  // 4) equal-power norm gains (0-1)
  const normL = Math.sqrt(0.5 * (1 - pan));
  const normR = Math.sqrt(0.5 * (1 + pan));

  // 5) detect "behind" via forward dot
  const horizDist = Math.hypot(dx, dy) || 1; // avoid zero
  const forwardDot = dy / horizDist; // +1 = straight ahead, -1 = straight back
  const isBehind = forwardDot < 0;

  // 6) cross-feed: more bleed for rear sources
  const crossfeedFront = 0.2;
  const crossfeedBack = 0.4;
  const cf = isBehind ? crossfeedBack : crossfeedFront;
  const bleedL = normL * (1 - cf) + cf;
  const bleedR = normR * (1 - cf) + cf;

  // 7) rear attenuation: full strength front->1, taper to minRear behind
  const minRear = 0.6; // at 180 degrees straight back you're at 60% level
  const rearAtt = isBehind ? (1 + forwardDot) * (1 - minRear) + minRear : 1;

  // 8) elevation roll-off
  const elevAngle = Math.atan2(dz, horizDist);
  const elevationFact = Math.cos(elevAngle);

  // 9) final gains (scaled to [0-2])
  let left = bleedL * 2 * distanceFactor * elevationFact * rearAtt * senderVolume;
  let right = bleedR * 2 * distanceFactor * elevationFact * rearAtt * senderVolume;

  // clamp
  left = Math.min(2, Math.max(0, left));
  right = Math.min(2, Math.max(0, right));

  return [left, right];
}
